import React, { useMemo, useState } from "react";
import { buildApiUrl } from "../../config/api";
import "./auth.css";

const ResetPasswordPage = () => {
    const token = useMemo(() => {
        const params = new URLSearchParams(window.location.search);
        return params.get("token") || "";
    }, []);

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError("");
        setSuccess("");

        if (!token) {
            setError("链接无效，请重新请求密码重置邮件。");
            return;
        }

        if (!password || password.length < 6) {
            setError("密码长度至少 6 位。");
            return;
        }

        if (password !== confirmPassword) {
            setError("两次输入的密码不一致。");
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(buildApiUrl("/api/auth/password/reset"), {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token, password })
            });
            const data = await response.json();

            if (response.ok) {
                setSuccess("密码已成功重置，请使用新密码登录。");
                setPassword("");
                setConfirmPassword("");
            } else {
                setError(data.error || "重置失败，请重新请求。");
            }
        } catch (err) {
            setError("网络异常，请稍后再试。");
        } finally {
            setLoading(false);
        }
    };

    const goToHome = () => {
        window.location.href = "/";
    };

    return (
        <div className="auth-page">
            <div className="auth-panel">
                <header className="auth-panel__header">
                    <span className="auth-panel__brand">DoneLog</span>
                    <h2>设置新密码</h2>
                    <p>请为你的账户设置一个全新的密码。</p>
                </header>

                {error && <div className="auth-panel__message auth-panel__message--error">{error}</div>}
                {success && <div className="auth-panel__message auth-panel__message--success">{success}</div>}

                <form className="auth-panel__form" onSubmit={handleSubmit}>
                    <div className="auth-panel__field">
                        <label htmlFor="reset-password">新密码</label>
                        <input
                            id="reset-password"
                            type="password"
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                            className="auth-panel__input"
                            placeholder="不少于 6 位字符"
                            required
                            disabled={loading}
                        />
                    </div>
                    <div className="auth-panel__field">
                        <label htmlFor="reset-password-confirm">确认新密码</label>
                        <input
                            id="reset-password-confirm"
                            type="password"
                            value={confirmPassword}
                            onChange={(event) => setConfirmPassword(event.target.value)}
                            className="auth-panel__input"
                            placeholder="再次输入新密码"
                            required
                            disabled={loading}
                        />
                    </div>
                    <button type="submit" className="btn primary auth-panel__submit" disabled={loading}>
                        {loading ? "重置中..." : "确认重置"}
                    </button>
                </form>

                <footer className="auth-panel__switch">
                    <span>返回登录？</span>
                    <button type="button" className="auth-panel__link" onClick={goToHome} disabled={loading}>
                        前往首页
                    </button>
                </footer>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
